import React from 'react'
import { Modal } from 'antd'
import { t } from '../../../../config/i18n'

interface Props {
  show: boolean
  onApply: () => void
  onClose: () => void
  children: React.ReactNode
}

export const FilterModal = ({ show, onApply, onClose, children }: Props) => (
  <Modal
    visible={show}
    title={t.common.filter}
    okText={t.common.apply}
    cancelText={t.common.cancel}
    onOk={onApply}
    onCancel={onClose}
  >
    {children}
  </Modal>
)
